import { TEAM_ROLE_LABELS } from 'modules/arena/onboarding/content';
import { Card } from 'shared/components/ui/Card';
import { Avatar } from 'shared/components/ui/Avatar';
import { Button } from 'shared/components/ui/Button';
import { useToast } from 'shared/components/ui/Toast';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';
import { useAuth } from 'shared/hooks/useAuth';

export function TeamList() {
  const toast = useToast();
  const { user } = useAuth();
  const { profile, isCustom } = useArenaProfile();
  // O dono é quem cadastrou a arena; sem cadastro, a proprietária do mock.
  const ownerName = (isCustom ? user?.name ?? profile.ownerName : profile.ownerName) ?? 'Proprietário(a)';
  const members = [
    { id: 'owner', name: ownerName, role: 'Proprietário(a)' },
    ...profile.team.map((member) => ({ id: member.id, name: member.name, role: TEAM_ROLE_LABELS[member.role] })),
  ];

  return (
    <Card>
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-ink">Equipe e instrutores</h3>
        <Button
          variant="ghost"
          className="px-3 py-1 text-xs"
          onClick={() =>
            toast({
              tone: 'info',
              title: 'Convidar para a equipe',
              description: 'Em breve: convite por e-mail com papel (gestor, recepção ou instrutor) e unidades permitidas.',
            })
          }
        >
          + Convidar
        </Button>
      </div>

      <div className="mt-3 flex flex-col gap-2">
        {members.map((member) => (
          <div key={member.id} className="flex items-center gap-3 rounded-xl border border-border/70 px-4 py-2">
            <Avatar name={member.name} size="sm" />
            <div>
              <p className="text-sm font-medium text-ink">{member.name}</p>
              <p className="text-xs text-ink-secondary">{member.role}</p>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
